import { render, staticRenderFns } from "./BaseSuggestionList.vue?vue&type=template&id=7c9e933d&scoped=true&"
import script from "./BaseSuggestionList.vue?vue&type=script&lang=js&"
export * from "./BaseSuggestionList.vue?vue&type=script&lang=js&"
import style0 from "./BaseSuggestionList.vue?vue&type=style&index=0&id=7c9e933d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9e933d",
  null
  
)

export default component.exports